import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux'
import store from './Store/store'
import './index.css';
import './Assets/Styles/tokens.css';
import './Assets/Styles/fonts.css';
// Mobile revamp — fases entregues. Cada arquivo é inerte enquanto a
// sub-flag correspondente em FEATURE_FLAGS.MOBILE_REVAMP estiver false.
import './Assets/Styles/mobile-revamp/home.css';
import './Assets/Styles/mobile-revamp/search.css';
import './Assets/Styles/mobile-revamp/details.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './Services/sentry';

// Inicializa o Sentry antes de renderizar — captura inclusive erros no boot.
// No-op silencioso quando REACT_APP_SENTRY_DSN não está definida (dev local).
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
	<Provider store={store}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
